import axios from '@/axios.js'

const WEBCAMS_BASE_PATH = 'v4/webcams'

export default {
    getWebcams: async (resortUuid, parameters) => {
        try {

            let params = { params: { ...parameters, ...{ per_page: 30 } } }
            const response = await axios.editorapi.get(`${WEBCAMS_BASE_PATH}/${resortUuid}/no-cache`, params)
            return response.data.object

        } catch (error) {
            throw new Error(error)
        }
    },
    createWebcam: async (resortUuid, payload) => {
        try {
            const response = await axios.editorapi.post(`${WEBCAMS_BASE_PATH}/${resortUuid}`, payload)
            return response.data
        } catch (error) {
            throw new Error(error)
        }
    },
    saveWebcam: async (resortUuid, webcamUuid, payload) => {
        try {
            const response = await axios.editorapi.patch(`${WEBCAMS_BASE_PATH}/${resortUuid}/${webcamUuid}`, payload)
            return response.data
        } catch (error) {
            throw new Error(error)
        }
    },
    deleteWebcam: async (resortUuid, webcamUuid) => {
        try {
            const response = await axios.editorapi.delete(`${WEBCAMS_BASE_PATH}/${resortUuid}/${webcamUuid}`)
            return response.data
        } catch (error) {
            throw new Error(error)
        }
    },
    sortWebcams: async (resortUuid, webcamsOrdered) => {
        try {
            const response = await axios.editorapi.patch(`${WEBCAMS_BASE_PATH}/${resortUuid}`, { 'sorted_webcams': webcamsOrdered })
            return response.data
        } catch (error) {
            throw new Error(error)
        }
    }
}